import { useDispatch, useSelector } from 'react-redux'
import AnimatedPage from '../components/animatedPage'
import Banner from '../components/banner/banner'
import Template from '../components/vacancies/template'
import VacanciesSection from './../components/vacancies/vacanciesSection'
import VacanciesTable from './../components/vacancies/vacanciesTable'
import { useEffect } from 'react'
import { fetchVacanciesData } from '../redux/slice/vacanciesPage'
import { retrunAssets } from '../utils/getAssets'
import { DecodeHtml } from '../utils/decodeHtml'

const Vacancies = () => {
  const state = useSelector(state => state.vacancies)
  const dispatch = useDispatch()

  useEffect(() => {
    if (state?.data == null) {
      dispatch(fetchVacanciesData('vacancies'))
    }
  }, [state, dispatch])

  const vacanciesData = state?.data?.properties

  const text = vacanciesData?.title
  const bg =
    vacanciesData?.backgroundImage != null
      ? retrunAssets(vacanciesData?.backgroundImage[0]?.url)
      : ''

  const header = vacanciesData?.header

  const vacancies = vacanciesData?.vancanciesBox?.items?.map(item => {
    item = item?.content?.properties
    return {
      title: item?.title,
      description: DecodeHtml({ html: item?.richTextContent?.markup }),
      table: {
        title: item?.tableTitle,
        header: ['Name', 'Close Date'],
        content: item?.table?.items?.map(row => {
          let newRow = row?.content?.properties
          console.log(newRow)
          // if key is closingDate then formate the date to DD MMMM  YYYY
          if (newRow?.closingDate) {
            newRow = {
              ...newRow,
              closingDate: new Date(newRow?.closingDate).toLocaleDateString(
                'en-GB',
                { year: 'numeric', month: 'long', day: 'numeric' }
              )
            }
          }
          return Object.values(newRow)
        })
      }
    }
  })

  // const vacancies = [
  //     {
  //         section: {
  //             title: "General Vacancies",
  //             paragraphs: [
  //                 `Our people make our world better.It is people that make UNITEN what it is and staff are our most valuable asset.Our success is entirely dependent upon recruiting, training and supporting fantastic people.People who can make a difference and enable change.It is our people that allow us to operate as an agile and responsive energy university, custom built for a changing world.We are actively committed to growing and supporting a diverse workforce and welcome applications from all backgrounds.`,

  //                 `How to Apply`,

  //                 `1. Fill in the Borang UNITEN 188C(Luaran).Click the link to download the form.`,
  //                 `2. Attach a Curriculum Vitae and covering letter setting out clearly how you meet the criteria for the post.`,

  //                 `EITHER return them as Word (.doc) or Rich Text Format(.rtf) attachments by email to hr@uniten.edu.my including the post title in the email subject heading.`,

  //                 `OR by post to:`,

  //                 `Director(Human Resource)`,
  //                 `Universiti Tenaga Nasional(UNITEN)`,
  //                 `Putrajaya Campus`,
  //                 `Jalan IKRAM - UNITEN`,
  //                 `43000 Kajang, Selangor`,
  //                 `MALAYSIA.`,

  //                 `All applications must be received by 5 pm on the close date.`,

  //                 `Any query should be addressed to :`,
  //                 `E: hr@uniten.edu.my`,
  //                 `T: 03 - 8928 7160 / 03 - 8921 2020 ext. 7112, 1255, 1268`,
  //             ]
  //         },
  //         table: {
  //             title: "General Vacancies",
  //             header: ["Name", "Close Date"],
  //             content: [
  //                 ["Position A", "30/1/2021"],
  //                 ["Position B", "30/1/2021"],
  //                 ["Position C", "30/1/2021"],
  //                 ["Position D", "30/1/2021"],

  //             ]
  //         }
  //     },
  //     {
  //         section: {
  //             title: "Vacancies Vacancies",
  //             paragraphs: [
  //                 `Welcome to Vacancies Vacancies of UNITEN.`,

  //                 `Our people make our world better.It is people that make UNITEN what it is and staff are our most valuable asset.Our success is entirely dependent upon recruiting, training and supporting fantastic people.People who can make a difference and enable change.It is our people that allow us to operate as an agile and responsive energy university, custom built for a changing world.We are actively committed to growing and supporting a diverse workforce and welcome applications from all backgrounds`,
  //             ]
  //         },
  //         table: {
  //             title: "Vacancies Vacancies",
  //             header: ["Name", "Close Date"],
  //             content: [
  //                 ["Position A", "30/1/2021"],
  //                 ["Position B", "30/1/2021"],
  //                 ["Position C", "30/1/2021"],
  //                 ["Position D", "30/1/2021"],

  //             ]
  //         }
  //     },
  // ]

  return (
    <AnimatedPage>
      <Banner text={text} bg={bg} />
      <div className='relative bg-white  py-12 text-black w-full md:px-32 p-6 flex flex-col  gap-8'>
        <h1 className='w-auto   text-slate-900 text-4xl font-bold '>
          {header}
        </h1>
        <div className='grid grid-cols-1 lg:grid-cols-2 gap-5 w-full'>
          {vacancies?.map((vacancy, index) => {
            console.log(vacancy.table)
            return (
              <Template key={index}>
                <VacanciesSection
                  title={vacancy?.title}
                  paragraphs={vacancy?.description}
                />
                {vacancy?.table?.title != undefined && vacancy?.table?.content != undefined && (
                  <VacanciesTable
                    title={vacancy?.table?.title}
                    header={vacancy?.table?.header}
                    content={vacancy?.table?.content}
                  />
                )}
              </Template>
            )
          })}
        </div>
      </div>
    </AnimatedPage>
  )
}

export default Vacancies
